import { Auditable, Dto } from '@damofire/data-commons';

export interface ProductColor extends Dto<string>, Auditable {
  enabled?: boolean;
  code?: string;
  name?: string;
  description?: string;
}
